import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { dummyimage } from "../../assets/img";

const OwnerCancelDetails = ({ PriceDetails }) => {
  const settings = {
    dots: true,
    infinite: PriceDetails?.is_cancellation_booking?.images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: PriceDetails?.is_cancellation_booking?.images.length > 1,
    adaptiveHeight: true,
    draggable: PriceDetails?.is_cancellation_booking?.images.length > 1,
    swipe: PriceDetails?.is_cancellation_booking?.images.length > 1,
    touchMove: PriceDetails?.is_cancellation_booking?.images.length > 1,
    autoplay: true,
    easing: "linear",
    infinite: true,
  };

  return (
    <div className="roles-bg col-md-12 d-flex ac-jb ">
      {/* LEFT SIDE – IMAGE CAROUSEL */}
      <div className="col-md-5">
        {PriceDetails?.is_cancellation_booking?.images.length > 0 ? (
          <Slider {...settings}>
            {PriceDetails?.is_cancellation_booking?.images.map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt={`cancel-${index}`}
                  style={{
                    width: "100%",
                    height: "280px",
                    objectFit: "contain",
                    borderRadius: "10px",
                    backgroundColor: "#f5f5f5",
                  }}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = dummyimage;
                  }}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div>
            <img
              src={dummyimage}
              alt="no-image-available"
              style={{
                width: "100%",
                height: "280px",
                objectFit: "contain", // Using "contain" here too
                borderRadius: "10px",
              }}
            />
            <p className="gray mt-2 text-center">No images uploaded</p>
          </div>
        )}
      </div>

      {/* RIGHT SIDE – DETAILS */}
      <div className="col-md-6">
        <div className="d-flex ac-jb">
          <h2 className=" d-flex f4 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 mt-2">
            Cancellation Details
          </h2>
          <div>
            <p className="f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-18 gray">
              Cancel By
            </p>
            <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 primary">
              {PriceDetails?.is_cancellation_booking?.cancelled_by}
            </p>
            <p className="f2 fs-sm-8 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-13 primary">
              {PriceDetails?.is_cancellation_booking?.role || "Auto Canceled"}
            </p>
          </div>
        </div>
        <div className="my-4">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray">
            Cancelled Date & time
          </p>
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {moment(
              PriceDetails?.is_cancellation_booking?.cancellation_date,
            ).format("DD-MM-YYYY | h:mm A")}
          </p>
        </div>
        <div className="my-4">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            Reason
          </p>
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray">
            {PriceDetails?.is_cancellation_booking?.reason}
          </p>
        </div>
        <div className="my-4">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            Description
          </p>
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray">
            {PriceDetails?.is_cancellation_booking?.desc}
          </p>
        </div>
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  col-md-6">
          Price Refund
        </p>
        <div className="d-flex as-js ">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            user Amount
          </p>
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2">
            : {PriceDetails?.is_cancellation_booking?.user_amount}
          </p>
        </div>
        <div className="d-flex as-js ">
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray col-md-6">
            Vow Price
          </p>
          <p className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray2">
            : {PriceDetails?.is_cancellation_booking?.vow_profit}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OwnerCancelDetails;
